module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_5-80c6493c5672cbab957cbfee5ef41019.jpg";